import { IMqttAuth } from './IMqttAuth'
import { IMqttConfiguration } from './IMqttConfiguration'

export const parseMqttAuth = (data: { [key: string]: string }): IMqttAuth => {
    const mqttAuth: IMqttAuth = {}

    if (data['accessKey']) {
        mqttAuth.accessKey = data['accessKey']
    }
    if (data['secretKey']) {
        mqttAuth.secretKey = data['secretKey']
    }
    if (data['sessionKey']) {
        mqttAuth.sessionKey = data['sessionKey']
    }

    return mqttAuth
}

export const getMqttConfiguration = (config: IMqttAuth): IMqttConfiguration => ({
    method: 'GET',
    protocol: 'wss',
    canonicalUri: '/mqtt',
    service: 'iotdevicegateway',
    region: 'us-east-1',
    accessKey: config.accessKey || '',
    secretKey: config.secretKey || '',
    sessionKey: config.sessionKey || '',
    host: 'a3hkak4kt2zg42-ats.iot.us-east-1.amazonaws.com'
})
